module.exports = __webpack_public_path__ + "img/cubes.53251249.svg";